import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InfoPanelContainer = styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600,
    alignSelf: "stretch",
    padding: `${theme.space._600} ${theme.space._600} ${theme.space._700}`,
    backgroundColor: theme.colors["neutral.900"],
    borderRadius: "1rem",
    width: "100%"
}));

export const CustomTitle = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts.default,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
    fontSize: theme.fontSizes["5xl"],
    alignSelf: "stretch"
}));

export const ChildrenContainer = styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch",
}));
